module.exports = __webpack_public_path__ + "static/media/student1.36bc2b97.svg";